
import { hydrateCSRTemplate } from "@fiverr-private/layout_lib/CSRTemplate";

import RealtimeMessages from '/home/circleci/app/packages/layout-realtime-messages-component/src/entries/RealtimeMessages';

const element = typeof document !== 'undefined' && document.querySelector('#RealtimeMessages');
if (element) {
    const props = window.initialData['RealtimeMessages'];

    hydrateCSRTemplate(RealtimeMessages, props, element, 'RealtimeMessages', 'RealtimeMessages');
}
export default RealtimeMessages;
